import React from "react";

const Difference = () => {
  return (
    <section id="difference" className="pc-section papercraft pc-section--alt">
      <header className="pc-section__head">
        <span className="pc-eyebrow">Our quiet commitment</span>
      </header>

      <figure className="pc-pullquote">
        <span className="pc-pullquote__mark" aria-hidden>“</span>
        <blockquote className="pc-pullquote__body">
          By creating a positive online experience, we hope more hosts will
          consider sending invitations <em>electronically</em> for formal events —
          to help save trees, time, and money. A percentage of every sale supports
          a non-profit that maintains forests. Together we can <em>invite</em> a greener future.
        </blockquote>
        <figcaption className="pc-pullquote__sig">Making a difference</figcaption>
      </figure>
    </section>
  );
};

export default Difference;
